// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_cd-b";
export var colorBlue = "_cd-8";
export var colorDot = "_cd-0";
export var colorDotLarge = "_cd-2";
export var colorDotSmall = "_cd-1";
export var colorGreen = "_cd-7";
export var colorGrey = "_cd-3";
export var colorOrange = "_cd-5";
export var colorPink = "_cd-a";
export var colorPurple = "_cd-9";
export var colorRed = "_cd-4";
export var colorYellow = "_cd-6";